export default class Colors {
    background = '#F7F6F4';
    grey ='#EFECE5';
    palette = ['#4661ff', '#FAD117', '#4DE4C3', '#F5586F', '#4DED93', '#B761FF', '#00bcd4','#ff5722'];
}